import React, { useEffect, useState } from "react";
import { Link, useFetcher, useLocation, useParams } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash,
  faFilePen,
  faTrashCan,
  faCircle, faAngles,
  faUpDownLeftRight


,
} from "@fortawesome/free-solid-svg-icons";

import styles from "../../styles/locationDetail.module.css";
import data from "../../data/account_detail.json";
import search from "../../assets/images/search.png";
import { BASE_URL } from "../../utils/constants";
import axios from "axios";
import toast from "react-hot-toast";
import Spinner from "../../components/spinner";
import Tooltip from "../../components/shared-modules/Tooltip";
import Button from "../../components/button-v1";
import AlertDialog from "../../components/alert-dialogue";
import {
  AddLocationStaffModal,
  DeleteStaff,
  EditLocationStaffModal,
} from "./locationStaffModal";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogBody,
} from "../../components/ui/dialog";

import { EditStaffModal } from "./addStaffModal";
import Table from "../../components/table";
import ChronicConditionOptions from "./location/chronic-condition-options/chronicConditionOptions";
import { AddChronicConditionOption } from "../../pages/admin/chronicOptionModals";
import { getChronicConditionOptions } from "../../services/admin/chronicConditions";
import MedicationOptions from "./location/medication_option/medicationOptions";
import AddMedicationOptionModal from "./location/medication_option/AddMedicationOptionModal";
import { handleApiError } from "../../utils/handleApiError";
import { AddStaffModal, EditLocStaffModal } from "../staff/staffModal";
import { deactivatePatient } from "../../services/patient/settings";
import { getNoteTemplates } from "../../services/location";
import {
  AddNoteTemplateModal,
  EditNoteTemplateModal,
  DeleteNoteTemplateModal,
} from "../../components/note-templates";
import { displayDate, formatDate } from "../../utils/helper";
import MovePatientModal from "./MovePatientModal";

const LocationDetail = () => {
  const { id: location_id } = useParams();
  const queryClient = useQueryClient();
  const account_id = sessionStorage.getItem("acc_id");
  const patientId = sessionStorage.getItem("_pt_id");

  const [activeTab, setActiveTab] = useState("patients");
  const [nameSearch, setNameSearch] = useState("");
  const [providerSearch, setProviderSearch] = useState("");
  const [positionSearch, setPositionSearch] = useState("");
  const [locationInfo, setLocationInfo] = useState("");
  const [staffList, setStaffList] = useState([]);
  const [patientList, setPatientList] = useState([]);
  // const [conditionOptionList, setConditionOptionList] = useState([]);
  const [isAddStaffOpen, setIsAddStaffOpen] = useState(false);
  const [isChronicOptionModalOpen, setIsChronicOptionModalOpen] =
    useState(false);

  const [isAddNotetemplateModalOpen, setIsAddNotetemplateModalOpen] =
    useState(false);

  const [isEditNoteTemplateOpen, setIsEditNoteTemplateOpen] = useState(false);
  const [isDeleteNoteTemplateOpen, setIsDeleteNoteTemplateOpen] =
    useState(false);
  const [currentNoteTemplate, setCurrentNoteTemplate] = useState(null);

  const [isMedicationOptionModalOpen, setMedicationOptionModalOpen] =
    useState(false);

  const [ParentstaffList, setParentStaffList] = useState([]);
  const [reMountStaff, setreMountStaff] = useState(false);
  const [reMountChronicOption, setreMountChronicOption] = useState(false);
  const [isEditStaffOpen, setIsEditStaffOpen] = useState(false);
  const [isDeleteStaffModalOpen, setIsDeleteStaffModalOpen] = useState(false);
  const [currentStaffId, setCurrentStaffId] = useState(null);
  const [showDeletedPatients, setShowDeletedPatients] = useState(false);
  const [showDeactivateModal, setShowDeactivateModal] = useState(false);
  const [deactivateReason, setDeactivateReason] = useState("");
  const [activatePatientId, setActivatePaitentId] = useState(null);
  const [isMovePatientOpen, setIsMovePatientOpen] = useState(false);
  const [movingPatients, setMovingPatients] = useState(false);

  const [selectedPatients, setSelectedPatients] = useState([])
  const [selectedPatientIds, setSelectedPatientIds] = useState([])


  const openMovePatientModal = (patientsArray) => {
    setSelectedPatients(Array.isArray(patientsArray) ? patientsArray : [patientsArray])
    setIsMovePatientOpen(true)
    document.body.style.overflow = "hidden"
  }

  const closeMovePatientModal = () => {
    setIsMovePatientOpen(false)
    setSelectedPatients([])
    document.body.style.overflow = "auto"
  }


  const [loading, setLoading] = useState({
    component: true,
    account_staff: true,
    parent_staff: true,
    patient: true,
    // condition_options: true
  });
  const location = useLocation();

  const deactivatePatientMutation = useMutation(
    ({ patientId, body }) => deactivatePatient({ patientId, body }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["locationPatients"]);
        setActivatePaitentId(null);
        setShowDeactivateModal(false);
        setDeactivateReason("");
      },
    }
  );

  const noteTemplatesQuery = useQuery(
    ["note_templates", location_id],
    () => getNoteTemplates(location_id),
    {
      enabled: !!location_id,
    }
  );

  const noteTemplates = noteTemplatesQuery?.data;

  // Add Staff modal functions
  const openAddStaffModal = () => {
    setIsAddStaffOpen(true);
    document.body.style.overflow = "hidden";
  };
  const closeAddStaffModal = () => {
    setIsAddStaffOpen(false);
    document.body.style.overflow = "auto";
  };

  // Edit Staff modal functions
  const openEditStaffModal = (id) => {
    setCurrentStaffId(id);
    setIsEditStaffOpen(true);
    document.body.style.overflow = "hidden";
  };
  const closeEditStaffModal = () => {
    setIsEditStaffOpen(false);
    document.body.style.overflow = "auto";
  };

  // Delete staff modal functions
  const openDeleteStaffModal = (id) => {
    setCurrentStaffId(id);
    setIsDeleteStaffModalOpen(true);
    document.body.style.overflow = "hidden";
  };
  const closeDeleteStaffModal = () => {
    setIsDeleteStaffModalOpen(false);
    document.body.style.overflow = "auto";
  };
  const openMedicationOptionModal = () => {
    setMedicationOptionModalOpen(true);
  };

  const closeMedicationOptionModal = () => {
    setMedicationOptionModalOpen(false);
  };

  // Add Chronic Condition modal functions
  const openChronicOptionModal = () => {
    setIsChronicOptionModalOpen(true);
    document.body.style.overflow = "hidden";
  };
  const closeChronicOptionModal = () => {
    setIsChronicOptionModalOpen(false);
    document.body.style.overflow = "auto";
  };

  const openAddNoteTemplateModal = () => {
    setIsAddNotetemplateModalOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeNoteTemplateModal = () => {
    setIsAddNotetemplateModalOpen(false);
    document.body.style.overflow = "auto";
  };

  const openEditNoteTemplateModal = (noteTemplate) => {
    setCurrentNoteTemplate(noteTemplate);
    setIsEditNoteTemplateOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeEditNoteTemplateModal = () => {
    setIsEditNoteTemplateOpen(false);
    setCurrentNoteTemplate(null);
    document.body.style.overflow = "auto";
  };

  const openDeleteNoteTemplateModal = (noteTemplate) => {
    setCurrentNoteTemplate(noteTemplate);
    setIsDeleteNoteTemplateOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeDeleteNoteTemplateModal = () => {
    setIsDeleteNoteTemplateOpen(false);
    setCurrentNoteTemplate(null);
    document.body.style.overflow = "auto";
  };

  useEffect(() => {
    const fetchLocationInfo = async () => {
      setLoading((prevState) => ({ ...prevState, component: true }));
      const token = localStorage.getItem("authToken");
      const account_id = sessionStorage.getItem("acc_id");
      const url = `${BASE_URL}/accounts/${account_id}/location/${location_id}/`;

      try {
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setLocationInfo(response.data.location);
        setLoading((prevState) => ({ ...prevState, component: false }));
      } catch (error) {
        handleApiError(error);
      }
    };
    fetchLocationInfo();
  }, []);

  const {
    data: patientsData,
    isFetching: isFetchingPatients,
    isLoading: isLoadingPatients,
    refetch: refetchPatients,
  } = useQuery({
    queryKey: ["locationPatients", account_id, location_id, showDeletedPatients],
    enabled: activeTab === "patients",
    queryFn: async () => {
      const token = localStorage.getItem("authToken");
      const account_id = sessionStorage.getItem("acc_id");
      const url = `${BASE_URL}/patients/${account_id}/${location_id}/patients/${showDeletedPatients ? "?only_active=false" : ""}`;
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
        // full list for this admin table + its client-side search/counts (the
        // endpoint paginates by default now; we don't paginate this page yet).
        params: { pagination: "false" },
      });
      return response.data;
    },
    onSuccess: (data) => {
      setPatientList(data);
    },
    onError: (error) => {
      handleApiError(error);
    },
  });

  useEffect(() => {
    setLoading((prev) => ({ ...prev, patient: isLoadingPatients }));
  }, [isLoadingPatients]);

  useEffect(() => {
    const fetchStaffList = async () => {
      setLoading((prevState) => ({ ...prevState, account_staff: true }));
      const token = localStorage.getItem("authToken");
      const account_id = sessionStorage.getItem("acc_id");
      const url = `${BASE_URL}/accounts/${account_id}/${location_id}/staff-list/?status=active`;

      try {
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setStaffList(
          response.data.staff.filter(
            (staff) => staff.account_role?.name !== "Super User"
          )
        );
        setLoading((prevState) => ({ ...prevState, account_staff: false }));
      } catch (error) {
        handleApiError(error);
      }
    };

    // if (activeTab === "location_staff") {
    //   fetchStaffList();
    // }
    fetchStaffList();
  }, [reMountStaff, activeTab]);

  useEffect(() => {
    const fetchParentStaffList = async () => {
      setLoading((prevState) => ({ ...prevState, parent_staff: true }));
      const token = localStorage.getItem("authToken");
      const account_id = sessionStorage.getItem("acc_id");
      const url = `${BASE_URL}/accounts/${account_id}/staff-list/?status=active`;

      try {
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setParentStaffList(
          response.data.staff.filter((staff) => staff.account_role !== null)
        );
        setLoading((prevState) => ({ ...prevState, parent_staff: false }));
      } catch (error) {
        handleApiError(error);
      }
    };

    if (activeTab === "parent_account_staff") {
      fetchParentStaffList();
    }
  }, [reMountStaff, activeTab]);

  // fetching conditions options using useQuery
  const { data: conditionOptionList, isLoading } = useQuery({
    queryKey: ["chronicConditionOptions", location_id],
    queryFn: () => getChronicConditionOptions(location_id),
    enabled: activeTab === "chronic_condition_options",
  });

  // const formatDate = (dateString) => {
  //   const date = new Date(dateString);
  //   const day = String(date.getDate()).padStart(2, "0");
  //   const month = String(date.getMonth() + 1).padStart(2, "0");
  //   const year = date.getFullYear();
  //   return `${day}-${month}-${year}`;
  // };

  const filteredData =
    activeTab === "patients"
      ? // Patients data filteration
      (patientsData?.patients || []).filter((row) => {
        const fullName = `${row.first_name} ${row.last_name}`.toLowerCase();
        return fullName.includes(nameSearch.toLowerCase());
      })
      : activeTab === "location_staff"
        ? // staff data filteration
        staffList.filter((row) => {
          const fullName =
            `${row.user.first_name} ${row.user.last_name}`.toLowerCase();
          const matchesName = fullName.includes(nameSearch.toLowerCase());
          const matchesPosition = row?.account_position?.title
            .toLowerCase()
            .includes(positionSearch.toLowerCase());
          return matchesName && matchesPosition;
        })
        : activeTab === "parent_account_staff"
          ? // staff data filteration
          ParentstaffList.filter((row) => {
            const fullName =
              `${row?.user?.first_name} ${row?.user?.last_name}`.toLowerCase();
            const matchesName = fullName.includes(nameSearch.toLowerCase());
            const matchesPosition = row?.account_position?.title
              .toLowerCase()
              .includes(positionSearch.toLowerCase());

            return matchesName && matchesPosition;
          })
          : activeTab === "note_templates"
            ? noteTemplates?.filter((row) => {
              const matchesName = row?.note_template_text
                .toLowerCase()
                .includes(nameSearch.toLowerCase());
              return matchesName;
            })
            : // statuses data filteration
            data.statuses.filter((row) => {
              const matchesName = row?.name
                .toLowerCase()
                .includes(nameSearch.toLowerCase());
              return matchesName;
            });

  const patientTableColumns = [
    {
      key: "name",
      label: "Name",
      alignLeft: true,
      render: (row) => `${row.first_name} ${row.last_name}`,
    },
    { key: "email", label: "Email", alignLeft: true },
    {
      key: "phone",
      label: "Phone",
      render: (row) => row.primary_phone,
      sorting: false,
    },
    {
      key: "prefered_lenguage",
      label: "Prefered language",
      render: (row) => row.preferred_language,
    },
    {
      key: "program",
      label: "Program",
      render: (row) =>
        row.rpm && row.ccm
          ? "RPM | CCM"
          : row.rpm
            ? "RPM"
            : row.ccm
              ? "CCM"
              : "None",
    },

    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className={styles.action_btns}>
        


          {showDeletedPatients ? (
            <Button
              loading={activatePatientId === row.id}
              disabled={activatePatientId === row.id}

              onClick={() => {
                setActivatePaitentId(row.id);
                deactivatePatientMutation.mutate(
                  {
                    patientId: row.id,
                    body: {
                      user: { is_active: true, deactivation_reason: "" },
                    },
                  },
                  {
                    onSuccess: () =>
                      toast.success("Patient activated successfully."),
                    onError: () => toast.error("Could not activate patient"),
                  }
                );
              }}
            >
              Activate
            </Button>
          ) : (
          <>  <Button
              variant="ghost"
            title="Delete Patient"

              onClick={(e) => {
                e.stopPropagation();
                setActivatePaitentId(row.id);
                setShowDeactivateModal(true);
              }}
            >
              <FontAwesomeIcon icon={faTrashCan} />
            </Button>
              {/* Move Patient */}
          <Button
            variant="ghost"
            onClick={(e) => {
              e.stopPropagation();
              openMovePatientModal([row]);
            }}
            title="Move Patient"
            aria-label="Move Patient"
          >
            <FontAwesomeIcon icon={faUpDownLeftRight


} />
          </Button>
            </>
          )}
        </div>
      ),
    }

  ];

  const accountStaffTableColumns = [
    // { key: "id", label: "ID", alignLeft: true },
    {
      key: "name",
      label: "Name",
      alignLeft: true,
      render: (row) => `${row.user.first_name} ${row.user.last_name}`,
    },
    {
      key: "email",
      label: "Email",
      alignLeft: true,
      render: (row) => row.user.email,
    },
    {
      key: "position",
      label: "Position",
      render: (row) => row.account_position.title,
    },
    {
      key: "patients",
      label: "Patients",
      render: (row) =>
        row.account_roles?.some((role) => role.name === "Account Admin")
          ? "ALL"
          : row.assigned_patients_count,
    },
    {
      key: "actions",
      sorting: false,
      label: "Actions",
      render: (row) => (
        <div className={styles.action_btns}>
          <Button variant="ghost" onClick={() => openEditStaffModal(row.id)}>
            <FontAwesomeIcon className={styles.edit} icon={faFilePen} />
          </Button>
          <Button variant="ghost" onClick={() => openDeleteStaffModal(row.id)}>
            <FontAwesomeIcon className={styles.delete} icon={faTrashCan} />
          </Button>
        </div>
      ),
    },
  ];

  const parentStaffTableColumns = [
    // { key: "id", label: "ID", alignLeft: true },
    {
      key: "name",
      label: "Name",
      alignLeft: true,
      render: (row) => `${row.user.first_name} ${row.user.last_name}`,
    },
    {
      key: "email",
      label: "Email",
      alignLeft: true,
      render: (row) => row.user.email,
    },
    {
      key: "position",
      label: "Position",
      render: (row) => row.account_position.title,
    },
    {
      key: "actions",
      sorting: false,
      label: "Actions",
      render: (row) => (
        <div className={styles.action_btns}>
          <Button variant="ghost" onClick={() => openEditStaffModal(row.id)}>
            <FontAwesomeIcon className={styles.edit} icon={faFilePen} />
          </Button>
          <Button variant="ghost" onClick={() => openDeleteStaffModal(row.id)}>
            <FontAwesomeIcon className={styles.delete} icon={faTrashCan} />
          </Button>
        </div>
      ),
    },
  ];

  const noteTemplateColumns = [
    // { key: "id", label: "ID", alignLeft: true },
    {
      key: "id",
      label: "ID",
      alignLeft: true,
    },
    {
      key: "note_template_text",
      label: "Text",
      alignLeft: true,
      render: (row) => (
        <section style={{ textWrap: "wrap", width: "80%" }}>
          <p>{row.note_template_text}</p>
        </section>
      ),
    },
    {
      key: "created_at",
      label: "Created At",
      render: (row) => displayDate(row.created_at),
    },

    {
      key: "actions",
      sorting: false,
      label: "Actions",
      render: (row) => (
        <div className={styles.action_btns}>
          <Button
            variant="ghost"
            onClick={() => openEditNoteTemplateModal(row)}
          >
            <FontAwesomeIcon className={styles.edit} icon={faFilePen} />
          </Button>
          <Button
            variant="ghost"
            onClick={() => openDeleteNoteTemplateModal(row)}
          >
            <FontAwesomeIcon className={styles.delete} icon={faTrashCan} />
          </Button>
        </div>
      ),
    },
  ];

  // const formatJsonData = (data) => {
  //   return data.map((item) => {
  //     let formattedItem = {};

  //     Object.keys(item).forEach((key) => {
  //       if (typeof item[key] === "string") {
  //         if (item[key].includes("\n")) {
  //           // Convert new-line separated values into an array
  //           formattedItem[key] = item[key]
  //             .split("\n")
  //             .map((entry) => entry.trim());
  //         } else if (item[key].includes(":::")) {
  //           // Convert "title:::description" formatted text into an array of objects
  //           formattedItem[key] = item[key].split("\n").map((entry) => {
  //             const [title, description] = entry.split(":::");
  //             return { title: title.trim(), description: description?.trim() };
  //           });
  //         } else {
  //           // If it's a normal string, keep it as is
  //           formattedItem[key] = item[key].trim();
  //         }
  //       } else {
  //         // If it's not a string, keep it as is (like numbers, arrays, objects)
  //         formattedItem[key] = item[key];
  //       }
  //     });

  //     return formattedItem;
  //   });
  // };

  return (
    <div className={styles.admin_page}>
      <div className={styles.admin_page_container}>
        {loading.component ? (
          <div className={styles.spinner_container}>
            <Spinner />
          </div>
        ) : (
          <>
            {/* ===== dashboard =====  */}
            <div className={styles.dashboard_wrapper}>
              <p className={styles.heading}>{locationInfo.name}</p>

              <div className={styles.dashboard_container}>
                <div className={styles.dashboard}>
                  <div className={styles.dash_item}>
                    <div className={styles.dashboard_heading}>
                      <p>Created On</p>
                      <Tooltip
                        content={`Creation date of ${locationInfo?.name}`}
                        position="top"
                      >
                        <span>?</span>
                      </Tooltip>
                    </div>

                    <div className={styles.value}>
                      <p>{displayDate(locationInfo.created_at)}</p>
                    </div>
                  </div>

                  <div className={styles.dash_item}>
                    <div className={styles.dashboard_heading}>
                      <p>Location Staff</p>
                      <Tooltip
                        content={`Total Staff count of ${locationInfo?.name}`}
                        position="top"
                      >
                        <span>?</span>
                      </Tooltip>
                    </div>

                    <div className={styles.value}>
                      <p>
                        {
                          staffList.filter(
                            (_patient) => _patient.account_position?.title
                          ).length
                        }
                      </p>
                    </div>
                  </div>

                  <div className={styles.dash_item}>
                    <div className={styles.dashboard_heading}>
                      <p>Total Patients</p>
                      <Tooltip
                        content={`Total Patient(s) onboarded in ${locationInfo?.name}`}
                        position="top"
                      >
                        <span>?</span>
                      </Tooltip>
                    </div>

                    <div className={styles.value}>
                      <p>{(patientsData?.patients || []).length}</p>
                    </div>
                  </div>
                  <div className={styles.dash_item}>
                    <div className={styles.dashboard_heading}>
                      <p>Active Patients</p>
                      <Tooltip
                        content={`Total Active Patient(s) in ${locationInfo?.name}`}
                        position="top"
                      >
                        <span>?</span>
                      </Tooltip>
                    </div>

                    <div className={styles.value}>
                      <p>
                        {
                          (patientsData?.patients || []).filter(
                            (_patient) => _patient.is_active
                          ).length
                        }
                      </p>
                    </div>
                  </div>
                  <div className={styles.dash_item}>
                    <div className={styles.dashboard_heading}>
                      <p>In-Active Patients</p>
                      <Tooltip
                        content={`Total In-Active Patient(s) in ${locationInfo?.name}`}
                        position="top"
                      >
                        <span>?</span>
                      </Tooltip>
                    </div>

                    <div className={styles.value}>
                      <p>
                        {
                          (patientsData?.patients || []).filter(
                            (_patient) => !_patient.is_active
                          ).length
                        }
                      </p>
                    </div>
                  </div>
                </div>

                {/* <div className={styles.actions_wrapper}>
                  <div className={styles.action}>
                    <div className={styles.action_img}>
                      <img
                        src={
                          require(`../../assets/images/paper_plane.png`).default
                        }
                        alt=""
                      />
                    </div>
                    <p className={styles.action_heading}>Order Devices</p>
                  </div>
                </div> */}
              </div>
            </div>

            {/* ===== Data ===== */}
            <div className={styles.patient_wrapper}>
              <div className={styles.toggle_wrapper}>
                <p
                  className={`${styles.patient_toggle} ${activeTab === "patients" ? styles.active : ""
                    }`}
                  onClick={() => setActiveTab("patients")}
                >
                  Patients
                </p>
                {/* <p
                  className={`${styles.patient_toggle} ${activeTab === "location_staff" ? styles.active : ""
                    }`}
                  onClick={() => setActiveTab("location_staff")}
                >
                  Location Staff
                </p> */}
                {/* <p
                  className={`${styles.patient_toggle} ${activeTab === "parent_account_staff" ? styles.active : ""
                    }`}
                  onClick={() => setActiveTab("parent_account_staff")}
                >
                  Parent Account Staff
                </p> */}

                <p
                  className={`${styles.patient_toggle} ${activeTab === "note_templates" ? styles.active : ""
                    }`}
                  onClick={() => setActiveTab("note_templates")}
                >
                  Note Options
                </p>

                {/* <p
                  className={`${styles.patient_toggle} ${
                    activeTab === "billing" ? styles.active : ""
                  }`}
                  onClick={() => setActiveTab("billing")}
                >
                  Billing
                </p> */}
                {/* <p
                  className={`${styles.patient_toggle} ${
                    activeTab === "note_options" ? styles.active : ""
                  }`}
                  onClick={() => setActiveTab("note_options")}
                >
                  Note Options
                </p> */}
                <p
                  className={`${styles.patient_toggle} ${activeTab === "chronic_condition_options"
                    ? styles.active
                    : ""
                    }`}
                  onClick={() => setActiveTab("chronic_condition_options")}
                >
                  Chronic Condition Options
                </p>
                {/* <p
                  className={`${styles.patient_toggle} ${
                    activeTab === "notification_subscribers"
                      ? styles.active
                      : ""
                  }`}
                  onClick={() => setActiveTab("notification_subscribers")}
                >
                  Notification Subscribers
                </p> */}
                <p
                  className={`${styles.patient_toggle} ${activeTab === "medication_options" ? styles.active : ""
                    }`}
                  onClick={() => setActiveTab("medication_options")}
                >
                  Medication Options
                </p>
                {/* <p
                  className={`${styles.patient_toggle} ${
                    activeTab === "statuses" ? styles.active : ""
                  }`}
                  onClick={() => setActiveTab("statuses")}
                >
                  Satuses
                </p> */}
              </div>

              <div className={styles.top}>
                {activeTab === "patients" ? (
                  <p className={styles.heading}>Patients</p>
                ) : activeTab === "location_staff" ? (
                  <p className={styles.heading}>
                    Staff{" "}
                    <small className={styles.count}>
                      ({filteredData.length})
                    </small>
                  </p>
                ) : activeTab === "parent_account_staff" ? (
                  <p className={styles.heading}>
                    Staff{" "}
                    <small className={styles.count}>
                      ({filteredData.length})
                    </small>
                  </p>
                ) : activeTab === "note_templates" ? (
                  <p className={styles.heading}>
                    Note Options
                    <small className={styles.count}>
                      ({filteredData.length})
                    </small>
                  </p>
                ) : activeTab === "chronic_condition_options" ? (
                  <p className={styles.heading}>Chronic Condition Options</p>
                ) : activeTab === "medication_options" ? (
                  <p className={styles.heading}>Medication Options</p>
                ) : (
                  <></>
                )}

                <div className={styles.top_left}>
                  {activeTab === "patients" ? (
                    <></>
                  ) : // <Linklocations
                    //   to="/patient/create-patient"
                    //   className={styles.top_btn}
                    // >
                    //   + Add Patient
                    // </Link>
                    activeTab === "location_staff" ? (
                      <p className={styles.top_btn} onClick={openAddStaffModal}>
                        + Add Staff
                      </p>
                    ) : activeTab === "billing" ? (
                      <p className={styles.top_btn}>Download CSV</p>
                    ) : activeTab === "note_templates" ? (
                      <p
                        className={styles.top_btn}
                        onClick={openAddNoteTemplateModal}
                      >
                        + Add Note Option
                      </p>
                    ) : activeTab === "chronic_condition_options" ? (
                      <p
                        className={styles.top_btn}
                        onClick={openChronicOptionModal}
                      >
                        + Add Chronic Condition
                      </p>
                    ) : activeTab === "notification_subscribers" ? (
                      <p className={styles.top_btn}>+ Add Subscriber</p>
                    ) : activeTab === "medication_options" ? (
                      <p
                        className={styles.top_btn}
                        onClick={openMedicationOptionModal}
                      >
                        + Add Medication Option
                      </p>
                    ) : (
                      activeTab === "statuses" && (
                        <p className={styles.top_btn}>+ Add Status</p>
                      )
                    )}
                </div>

                {/* {isAddStaffOpen && (
                  <AddLocationStaffModal
                    isOpen={isAddStaffOpen}
                    location_id={location_id}
                    onClose={closeAddStaffModal}
                    comp_renderer={setreMountStaff}
                    current_render={reMountStaff}
                  />
                )} */}

                {isAddStaffOpen && (
                  // <AddLocationStaffModal
                  //   isOpen={isAddStaffOpen}
                  //   location_id={location_id}
                  //   onClose={closeAddStaffModal}
                  //   comp_renderer={setreMountStaff}
                  //   current_render={reMountStaff}
                  // />
                  <AddStaffModal
                    isOpen={isAddStaffOpen}
                    location_id={location_id}
                    onClose={closeAddStaffModal}
                    comp_renderer={setreMountStaff}
                    current_render={reMountStaff}
                  />
                )}

                {isChronicOptionModalOpen && (
                  <AddChronicConditionOption
                    isOpen={isChronicOptionModalOpen}
                    location_id={location_id}
                    onClose={closeChronicOptionModal}
                  />
                )}

                {isMedicationOptionModalOpen && (
                  <AddMedicationOptionModal
                    isOpen={isMedicationOptionModalOpen}
                    onClose={closeMedicationOptionModal}
                  />
                )}
              </div>

              {activeTab === "patients" && (
                <div className={styles.table_container}>
                  <div className={styles.searchbar_container}>
                    <div className={styles.input_wrapper}>
                      <input
                        type="text"
                        placeholder="Search by Name"
                        value={nameSearch}
                        onChange={(e) => setNameSearch(e.target.value)}
                      />
                      <img src={search} alt="" />
                     
                    </div>
<div> {selectedPatientIds.length > 0 && !showDeletedPatients && (
                        <Button
                          variant="primary"
                          onClick={() => {
                            const selectedPatients = (patientsData?.patients || []).filter(p =>
                              selectedPatientIds.includes(p.id)
                            );
                            openMovePatientModal(selectedPatients);


                            openMovePatientModal(selectedPatients);
                          }}
                        >
                          Move Selected ({selectedPatientIds.length})
                        </Button>
                      )}   {showDeletedPatients ? (
                      <Button onClick={() => setShowDeletedPatients(false)}>
                        Show Active Patients
                      </Button>
                    ) : (
                      <Button
                        variant="ghost"
                        onClick={() => setShowDeletedPatients(true)}
                      >
                        Show Deleted Patients
                      </Button>
                      
                    )}</div>
                  


                  </div>


                  <hr className={styles.saparator} />

                  <div className={styles.all_patients}>
                    <Table
                      columns={patientTableColumns}
                      data={filteredData.filter((_patient) =>
                        showDeletedPatients
                          ? !_patient.is_active
                          : _patient.is_active
                      )}
                      height={500}
                      selectedIds={selectedPatientIds}
                      onSelectionChange={setSelectedPatientIds}
                      showCheckboxes
                      loading={loading.patient}
                    />
                  </div>
                </div>
              )}

              {activeTab === "location_staff" && (
                <div className={styles.table_container}>
                  <div className={styles.searchbar_container}>
                    <div className={styles.input_wrapper}>
                      <input
                        type="text"
                        placeholder="Search by Name"
                        value={nameSearch}
                        onChange={(e) => setNameSearch(e.target.value)}
                      />
                      <img src={search} alt="" />
                    </div>

                    <div className={styles.input_wrapper}>
                      <input
                        type="text"
                        placeholder="Search by Position"
                        value={positionSearch}
                        onChange={(e) => setPositionSearch(e.target.value)}
                      />
                      <img src={search} alt="" />
                    </div>
                  </div>

                  <hr className={styles.saparator} />

                  <div className={styles.all_patients}>
                    <Table
                      columns={accountStaffTableColumns}
                      data={filteredData}
                      loading={loading.account_staff}
                    />

                    {/* {isEditStaffOpen && (
                      <EditLocationStaffModal
                        isOpen={isEditStaffOpen}
                        onClose={closeEditStaffModal}
                        staff_info={
                          staffList
                            ? [...staffList].find(
                              (staff) => staff.id === currentStaffId
                            )
                            : {}
                        }
                        location_id={location_id}
                        comp_renderer={setreMountStaff}
                        current_render={reMountStaff}
                      />
                    )} */}

                    {isEditStaffOpen && (
                      <EditLocStaffModal
                        isOpen={isEditStaffOpen}
                        onClose={closeEditStaffModal}
                        staff_info={
                          staffList
                            ? [...staffList].find(
                              (staff) => staff.id === currentStaffId
                            )
                            : {}
                        }
                        location_id={location_id}
                        comp_renderer={setreMountStaff}
                        current_render={reMountStaff}
                      />
                    )}

                    {isDeleteStaffModalOpen && (
                      <DeleteStaff
                        isOpen={isDeleteStaffModalOpen}
                        onClose={closeDeleteStaffModal}
                        staff_info={
                          staffList
                            ? [...staffList].find(
                              (staff) => staff.id === currentStaffId
                            )
                            : {}
                        }
                        comp_renderer={setreMountStaff}
                        current_render={reMountStaff}
                      />
                    )}
                  </div>
                </div>
              )}

              {activeTab === "parent_account_staff" && (
                <div className={styles.table_container}>
                  <div className={styles.searchbar_container}>
                    <div className={styles.input_wrapper}>
                      <input
                        type="text"
                        placeholder="Search by Name"
                        value={nameSearch}
                        onChange={(e) => setNameSearch(e.target.value)}
                      />
                      <img src={search} alt="" />
                    </div>

                    <div className={styles.input_wrapper}>
                      <input
                        type="text"
                        placeholder="Search by Position"
                        value={positionSearch}
                        onChange={(e) => setPositionSearch(e.target.value)}
                      />
                      <img src={search} alt="" />
                    </div>
                  </div>

                  <hr className={styles.saparator} />

                  <div className={styles.all_patients}>
                    <Table
                      columns={parentStaffTableColumns}
                      data={filteredData}
                      loading={loading.parent_staff}
                    />

                    {isEditStaffOpen && (
                      <EditStaffModal
                        isOpen={isEditStaffOpen}
                        onClose={closeEditStaffModal}
                        staff_info={
                          ParentstaffList
                            ? [...ParentstaffList].find(
                              (staff) => staff.id === currentStaffId
                            )
                            : {}
                        }
                        comp_renderer={setreMountStaff}
                        current_render={reMountStaff}
                      />
                    )}

                    {isDeleteStaffModalOpen && (
                      <DeleteStaff
                        isOpen={isDeleteStaffModalOpen}
                        onClose={closeDeleteStaffModal}
                        staff_info={
                          ParentstaffList
                            ? [...ParentstaffList].find(
                              (staff) => staff.id === currentStaffId
                            )
                            : {}
                        }
                        comp_renderer={setreMountStaff}
                        current_render={reMountStaff}
                      />
                    )}
                  </div>
                </div>
              )}

              {activeTab === "billing" && (
                <div className={styles.table_container}>
                  <div className={styles.all_patients}>
                    <table className={styles.all_patient_table}>
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>RPM</th>
                          <th>Days</th>
                          <th>Setup</th>
                          <th>99453</th>
                          <th>99454</th>
                          <th>99457</th>
                          <th>99458</th>
                        </tr>
                      </thead>
                      <tbody></tbody>
                    </table>
                    <div className={styles.data_not_found}>No Data Found</div>
                  </div>
                </div>
              )}

              {activeTab === "note_templates" && (
                <div className={styles.table_container}>
                  <div className={styles.searchbar_container}>
                    <div className={styles.input_wrapper}>
                      <input
                        type="text"
                        placeholder="Search by Name"
                        value={nameSearch}
                        onChange={(e) => setNameSearch(e.target.value)}
                      />
                      <img src={search} alt="" />
                    </div>

                    {/* <div className={styles.input_wrapper}>
                      <input
                        type="text"
                        placeholder="Search by Position"
                        value={positionSearch}
                        onChange={(e) => setPositionSearch(e.target.value)}
                      />
                      <img src={search} alt="" />
                    </div> */}
                  </div>

                  <hr className={styles.saparator} />

                  <div className={styles.all_patients}>
                    <Table
                      columns={noteTemplateColumns}
                      data={filteredData ?? []}
                      loading={noteTemplatesQuery.isLoading}
                    />
                    {isAddNotetemplateModalOpen && (
                      <AddNoteTemplateModal
                        isOpen={isAddNotetemplateModalOpen}
                        location_id={location_id}
                        onClose={closeNoteTemplateModal}
                      />
                    )}

                    {isEditNoteTemplateOpen && currentNoteTemplate && (
                      <EditNoteTemplateModal
                        isOpen={isEditNoteTemplateOpen}
                        onClose={closeEditNoteTemplateModal}
                        location_id={location_id}
                        noteTemplate={currentNoteTemplate}
                      />
                    )}

                    {isDeleteNoteTemplateOpen && currentNoteTemplate && (
                      <DeleteNoteTemplateModal
                        isOpen={isDeleteNoteTemplateOpen}
                        onClose={closeDeleteNoteTemplateModal}
                        location_id={location_id}
                        noteTemplateId={currentNoteTemplate?.id}
                      />
                    )}

                    {isEditStaffOpen && (
                      <EditLocStaffModal
                        isOpen={isEditStaffOpen}
                        onClose={closeEditStaffModal}
                        staff_info={
                          staffList
                            ? [...staffList].find(
                              (staff) => staff.id === currentStaffId
                            )
                            : {}
                        }
                        location_id={location_id}
                        comp_renderer={setreMountStaff}
                        current_render={reMountStaff}
                      />
                    )}

                    {isDeleteStaffModalOpen && (
                      <DeleteStaff
                        isOpen={isDeleteStaffModalOpen}
                        onClose={closeDeleteStaffModal}
                        staff_info={
                          staffList
                            ? [...staffList].find(
                              (staff) => staff.id === currentStaffId
                            )
                            : {}
                        }
                        comp_renderer={setreMountStaff}
                        current_render={reMountStaff}
                      />
                    )}
                  </div>
                </div>
              )}

              {activeTab === "chronic_condition_options" && (
                <div className={styles.table_container}>
                  <div className={styles.section_body}>
                    {isLoading ? (
                      <Spinner />
                    ) : (
                      <div className={styles.conditions_container}>
                        {conditionOptionList.length > 0 ? (
                          <ChronicConditionOptions
                            conditionOptions={conditionOptionList || []}
                          />
                        ) : (
                          <div style={{ padding: "10px 15px" }}>
                            No Condition Option found
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              )}

              {activeTab === "notification_subscribers" && (
                <div className={styles.table_container}>
                  <div className={styles.all_patients}>
                    <table className={styles.all_patient_table}>
                      <thead>
                        <tr>
                          <th>Value</th>
                          <th>Type</th>
                          <th>Redirecting To</th>
                          <th>Created At</th>
                          <th>Notifications</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody></tbody>
                    </table>
                    <div className={styles.data_not_found}>No Data Found</div>
                  </div>
                </div>
              )}

              {activeTab === "medication_options" && (
                <div className={styles.table_container}>
                  <div className={styles.all_patients}>
                    <div className={styles.section_body}>
                      <MedicationOptions />
                    </div>
                  </div>
                </div>
              )}

              {activeTab === "statuses" && (
                <div className={styles.table_container}>
                  <div className={styles.searchbar_container}>
                    <div className={styles.input_wrapper}>
                      <input
                        type="text"
                        placeholder="Search by Name"
                        value={nameSearch}
                        onChange={(e) => setNameSearch(e.target.value)}
                      />
                      <img src={search} alt="" />
                    </div>
                  </div>

                  <hr className={styles.saparator} />

                  <div className={styles.all_patients}>
                    <table className={styles.all_patient_table}>
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Name</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredData.map((row, index) => (
                          <tr key={index}>
                            <td>{row.id}</td>
                            <td>{row.name}</td>
                            <td>
                              <FontAwesomeIcon
                                className={styles.trash}
                                icon={faTrash}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </>
        )}
      </div>
      {/* Deactivate Patient Modal */}
      <Dialog
        open={showDeactivateModal}
        setOpen={() => setShowDeactivateModal(false)}
      >
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Deactivate Patient</DialogTitle>
          </DialogHeader>
          <DialogBody>
            <div className={styles.content}>
              <textarea
                value={deactivateReason}
                onChange={(e) => setDeactivateReason(e.target.value)}
                className={styles.reason_textarea}
                autoFocus
                placeholder="Reason"
              />
            </div>
          </DialogBody>
          <DialogFooter>
            <Button
              disabled={deactivatePatientMutation.isLoading}
              variant="ghost"
              size="default"
              onClick={() => setShowDeactivateModal(false)}
            >
              Cancel
            </Button>
            <Button
              loading={deactivatePatientMutation.isLoading}
              disabled={deactivatePatientMutation.isLoading}
              variant="danger"
              onClick={() => {
                if (!deactivateReason) {
                  return toast.error(
                    "please provider reason to deactivate the patient"
                  );
                }
                deactivatePatientMutation.mutate(
                  {
                    patientId: activatePatientId,
                    body: {
                      user: {
                        is_active: false,
                        deactivation_reason: deactivateReason,
                      },
                    },
                  },
                  {
                    onSuccess: () => toast.success("Deactivated successfully"),
                    onError: () => toast.error("Could not deactivated "),
                  }
                );
              }}
            >
              Deactivate
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    {isMovePatientOpen && selectedPatients.length > 0 && (
  <MovePatientModal
    isOpen={isMovePatientOpen}
    onClose={closeMovePatientModal}
    patients={selectedPatients}
    fromLocation={locationInfo}
    setMovingPatients={setMovingPatients}   // ✅ NEW
    onSuccess={async () => {
      await queryClient.invalidateQueries(["locationPatients"]); // wait
      setSelectedPatientIds([]);
      setSelectedPatients([]);
      setMovingPatients(false);              // ✅ stop loading AFTER list update
    }}
  />
)}



    </div>
  );
};

export default LocationDetail;
